/* eslint-disable @typescript-eslint/naming-convention */
export enum SectionKeys {
  PROJECT_SELECTION = 'ProjectSelection',
  COMMENTS_SYNC = 'CommentsSync',
  EPIC_MAPPING = 'EpicMapping',
  FIELDS_MAPPING = 'FieldsMapping',
  STATUS_SYNC = 'StatusSync',
  EMPTY = '',
}
